export const filterUnavailableTicketTemplates = (ticketTemplates = []) => {
  return ticketTemplates.filter(
    (ticketTemplate) => ticketTemplate.isAvailableToSale
  );
};
